import { render, staticRenderFns } from "./Optinisation.vue?vue&type=template&id=043dfc98&scoped=true&"
import script from "./Optinisation.vue?vue&type=script&lang=js&"
export * from "./Optinisation.vue?vue&type=script&lang=js&"
import style0 from "./Optinisation.vue?vue&type=style&index=0&id=043dfc98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043dfc98",
  null
  
)

export default component.exports